<template>
    <v-row>
        <v-btn @click="send" class="ma-5">
            Send resetName
        </v-btn>
    </v-row>
</template>
<script>
export default {
    data: () => ({
    }),
    methods: {
        send: function () {
            this.$emit('sendResetName');
        }
    }
}
</script>